// extracted by mini-css-extract-plugin
export default {"doctorstab":"doctor_doctorstab__sw3Al"};